import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
  Fab,
} from "@material-ui/core";
import DisputeTable from "./DisputeTable";
import AddIcon from "@material-ui/icons/Add";
import { usePageStyles } from "../../pageStyles";
import { PageComponent, AccessRights } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
import { useDisputeData } from "../../../data/clearing/dispute/hooks/useDisputeData";
import { useDisputeIndex } from "../../../data/clearing/dispute/hooks/useDisputeIndex";
import { useHistory } from "react-router-dom";
import { getDisputesEditLocation } from "../dispute/Locations";
import { PageDataStatus } from "../../../data/models";
import { DisputeFilterButton } from "./DisputeFilter";
import { useAuth } from "../../../data/auth/hooks";
import { DownloadButton, DownloadExcelButton } from "./DownloadButton";

const DisputePage: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  const [pageData, dispatchLoadDispute] = useDisputeData();
  const [pageIndex, dispatchSetIndex] = useDisputeIndex();

  React.useEffect(() => {
    if (pageData && pageData.status === PageDataStatus.DataInvalidated) {
      dispatchLoadDispute();
    }
  }, [dispatchLoadDispute, pageData]);

  const history = useHistory();

  const [auth] = useAuth();

  if (auth.status !== "successful") {
    return null;
  }

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="dlsDisputeTitle" />}
              action={<DisputeActions />}
            />
            <Divider />
            <CardContent>
              <DisputeTable
                pageIndex={pageIndex}
                pageData={pageData}
                onPageIndexChange={dispatchSetIndex}
                userAccessRights={userAccessRights}
                getData={dispatchLoadDispute}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      {userAccessRights === AccessRights.All && (
          <Fab
            color="secondary"
            aria-label="add"
            className={pageStyles.mainFab}
            onClick={() => history.push(getDisputesEditLocation())}
          >
            <AddIcon />
          </Fab>
        )}
    </>
  );
};

export const DisputeActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <DownloadButton />
    </Grid>
    <Grid item>
      <DownloadExcelButton />
    </Grid>
    <Grid item>
      <DisputeFilterButton />
    </Grid>
  </Grid>
);

export default DisputePage;
